import { getBrowser } from '@socialive/common';
import { useMemo } from 'react';

export default function IncompatibleBrowserType() {
  const versionIssue = useMemo(() => {
    const browser = getBrowser();
    const minBrowser = window.CONFIG.supportedBrowsers?.find(({ name }) => name === browser.name);
    if (minBrowser?.version > browser.version) {
      return { current: browser.version, required: minBrowser.version };
    }
    return undefined;
  }, []);

  return (
    <div className="modal-incompatible-browser-body-type">
      <h3>Sorry, this browser isn&#39;t supported</h3>
      <div className="incompatible-browser-desc">
        Unfortunately, this browser doesn&#39;t support some of the features required to provide a great experience with
        Socialive. Please use an up-to-date version of Chrome or Edge.
      </div>
      {versionIssue && (
        <div className="incompatible-browser-version">
          Your version {versionIssue.current} is lower than the minimum required {versionIssue.required}
        </div>
      )}
      <div className="browser-selections">
        <div className="flex flex-col items-center">
          <img src="/logo-chrome.png" alt="chrome" />
          <a href="https://www.google.com/chrome/" target="_blank" rel="noreferrer">
            Get Chrome
          </a>
        </div>
        <div className="flex flex-col items-center">
          <img src="/logo-edge.png" alt="edge" />
          <a href="https://www.microsoft.com/en-us/edge" target="_blank" rel="noreferrer">
            Get Edge
          </a>
        </div>
      </div>
    </div>
  );
}
